module.exports = __webpack_public_path__ + "static/media/cross.791abe0a.png";